import { render, staticRenderFns } from "./SaveConfigSettings.vue?vue&type=template&id=3f1e4302&scoped=true"
import script from "./SaveConfigSettings.vue?vue&type=script&lang=js"
export * from "./SaveConfigSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f1e4302",
  null
  
)

export default component.exports